module.exports = __webpack_public_path__ + "img/profile-placeholder.1225968c.png";